export default __webpack_public_path__ + "static/media/about-second-img.d13f0656.png";